import { Grid, Typography, TableRow, TableCell } from '@mui/material';
import { SuppliersMenu } from '../../../components/PredefinedMenus/PredefinedMenus';
import { useFormik } from 'formik';

import { useTranslation, getLanguage } from 'react-multi-lang';

import { havePermission } from '../../../services/hoc/permissions';
import { Cancel, Delete, Receipt, Save } from '@mui/icons-material';
import EditbleTable from '../../../components/editble-table/Editable_table_v1';
import  { iPurchaseOrder, iPurchaseOrderDetail, iPurchaseOrderResponse, orderStatus } from '../../../services/api/api';
import GreenButton from '../../../components/buttons/green-button';
import WhiteButton from '../../../components/buttons/white-button';
import { useNavigate } from 'react-router-dom';
import { useContext, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { convertDate } from '../../../services/convertDate';

import { useGetGlasses } from '../../../services/query/useGetGlasses';
import { WhiteboxLoader } from '../../../components/Loader/Loader';

import { Confirm } from '../../../components/Alerts/Alerts';
import { useNotification } from '../../../services/usenotification';
import { purchaseOrdersSlice } from './orderSlice';
import { useDispatch } from 'react-redux';
import {
  InputField,
  Textarea,
} from '../../../components/FormElements/FormElements';
import Backbutton from '../../../components/buttons/backbutton/backbutton';
import { UpdateOrderStatus } from './update_order_status';
import { IconButton } from '../../../components/icon-button';
import Title from '../../../components/Title/Title';
import InputTable from '../../../components/editble-table/input_table';
import SettingContext from '../../../services/context/setting-contentxt/setting-context';
import { checkIfTotallyFilled, enterButton } from '../../Order/common';
import { useAPI } from '../../../services/hoc/useAPI';
import { AddPurchaseOrderValidation } from './validation';
import { iGlassWorks } from '../../Order/OrderSlice';




interface iRow extends iPurchaseOrderDetail {

}








export const AddPurchaseOrder = () => {

  const t = useTranslation();

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formOptions, setFormOptions] = useState({ dirty: false, index: 0 });
  const dispatch = useDispatch();
  const [fetching, setFetching] = useState(false);
  const [disable, setDisable] = useState(true);

  const ref1 = useRef<any>(null);
  const ref2 = useRef<any>(null);
  const ref3 = useRef<any>(null);
  const ref4 = useRef<any>(null);
  const ref5 = useRef<any>(null);
  const ref6 = useRef<any>(null);
  const ref7 = useRef<any>(null);
  const ref8 = useRef<any>(null);
  
  const [row, setRow] = useState<iRow>({
    area: '',
    width: '',
    length: '',
    sheet_total: '',
    sheet_count: '',
    box_count: '',
    description: '',
    glass_id: '',
  });
  const [autoFilling, setAutoFilling] = useState({ field: '' });
  const { order_id } = useParams();
  const {isPc ,isMobile}=useContext(SettingContext)
  
  const [glasess, setGlasses] = useState<any[]>([]);
  const { alert, alertError500 } = useNotification();
  const { getGlasses, glassesError, glassesData, glassesDataLoading } =
    useGetGlasses();
const api = useAPI()
  const formik = useFormik<
    iPurchaseOrderResponse
  >({
    initialValues:{
      id:-1
    }
   ,
    onSubmit: () => {},
    validationSchema:AddPurchaseOrderValidation
  });
  // const handleAddLine = () => {
  //   if (order_id?havePermission("Edit Purchase Order"):havePermission("Add Purchase Order")){
  //   let new_fields = {
  //     area: '',
  //     width: '',
  //     length: '',
  //     sheet_total: '',
  //     sheet_count: '',
  //     box_count: '',
  //     description: '',
  //     glass_id: '',
  //   };
  //   formik.setFieldValue(
  //     `order_details[${Object.keys(formik.values.order_details).length}]`,
  //     new_fields,
  //   );
  // }
  // else {
  //   let message =t("no_edit_permission")
  //   alert({en:message,ar:message},'info')
  // }
  // };
  const addValuesTable = () => {
    let empty_row = {
      area: '',
      width: '',
      length: '',
      sheet_total: '',
      sheet_count: '',
      box_count: '',
      description: '',
      glass_id: '',
    };
    //let index = formik.values.order_details.length;
    let index = formik.values.purchaseorderdetail?.length;
    if (index === 0) {
      formik.setFieldValue('purchaseorderdetail', [{ ...row, serial_number: 1 }]);
      setRow((pre) => empty_row);
    } else {
      //let new_array = formik.values.order_details.filter(ele=>ele.glass_id);
      let new_array =formik.values.purchaseorderdetail?
       formik.values.purchaseorderdetail?.filter(ele=>ele.glass_id):[]
      let new_row = { ...row, serial_number: index };
      new_array.push(new_row);
      formik.setFieldValue('purchaseorderdetail', new_array);
      setRow((pre) => empty_row);
    }
   
  };

  const enterClicked = () => {
    let totally_filled = checkIfTotallyFilled(row);
    if (totally_filled) {
      addValuesTable();
      setFormOptions((pre) => ({ ...pre, dirty: true }))

      
    } else {
      alert(
        {
          en: 'Please you have to fill all the fileds',
          ar: 'رجاءا أدخل كل القيم أولا',
        },
        'info',
      );
    }
  };
  
  const generateTableBody = () => (
    <TableRow
      style={{
        width: '100%',
      }}
      sx={{
        '.MuiTableCell-root': {
          borderColor: 'lightgray',
          borderLeft: '1px solid lightgray',
          borderLeftStyle: 'groove',
        },
      }}>
      {isPc &&
        <TableCell>
        {enterButton(enterClicked)}
      </TableCell>}
      <TableCell colSpan={1}>
          <input
            ref={ref8}
            className="input  table_input "
            value={row.description}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
             handleRow(e)
            }
            name="description"
          />
        </TableCell>
     
        <TableCell colSpan={1}>
          <input
            ref={ref8}
            step={"any"}
            className="input  table_input "
            value={row.area}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>{}
              // setRow((pre: iRow) => ({ ...pre, area: e.target.value }))
            }
            name="area"
          />
      </TableCell>


     
      <TableCell colSpan={1}>
        <input
          ref={ref6}
          
          className="input  table_input "
          value={row.width}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
           handleRow(e)
          }
          name="width"
          type="number"
        />
        </TableCell>

    
      <TableCell colSpan={1}>
        <input
          ref={ref5}
          className="input  table_input "
          value={row.length}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
           handleRow(e)
          }
          name="length"
          type="number"
        />
      </TableCell>
    
      <TableCell colSpan={1} align="right">
        <input
          ref={ref4}
          className="input  table_input "
          value={row.sheet_total}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>{}
            // setRow((pre: iRow) => ({ ...pre, sheet_total: e.target.value }))
            
          }
          name="sheet_total"
          type="number"
        />
      </TableCell>
        <TableCell align="right" colSpan={1}>
        <input
          ref={ref3}
          className="input  table_input "
          value={row.sheet_count}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
           handleRow(e)
          }
          name="sheet_count"
          type="number"
        />
      </TableCell>

      <TableCell align="right" colSpan={1}>
        <input
          ref={ref2}
          className="input  table_input "
          value={row.box_count}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleRow(e)
          }
          name="box_count"
          type="number"
        />
      </TableCell>
        <TableCell
        colSpan={1}
        align="right"
      >
        <select
          ref={ref1}
          className="select"
          name="glass_id"
          value={row.glass_id as any}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
            setRow((pre) => ({
              ...pre,
              glass_id: e.target.value as string,
            }))
          }>
          <option value={''}></option>
          {glasess
            ? glasess.map((ele, index) => (
                <option value={ele.value ?? ''} key={`${index}-${ele}`}>
                  {ele.name ?? ''}
                </option>
              ))
            : null}
        </select>
      </TableCell>
    </TableRow>
  );

  const handleRow =(e:React.ChangeEvent<HTMLInputElement>)=>{
    let trigger_area_cacluation= {'width':'length','length':'width'}
    let trigger_sheets_clculation={'sheet_count':'box_count','box_count':'sheet_count'}
    let target=e.target  
    type row_key = keyof iRow
    let new_row:{[k in row_key]?:any}={...row}
    
   if (new_row) new_row[target.name as row_key]=target.value
    if (target.name.startsWith('width')){
      let area = calculate_area(parseInt(row.length??'0'),parseInt(target.value))
       new_row.area=area
    }
    if(target.name.startsWith('length')){
       let area = calculate_area(parseInt(target.value),parseInt(row.width??'0'))
       new_row.area=area
    }
    if(target.name.startsWith('sheet_count')){
      let sheet_total = calculate_total_sheets(parseInt(row.box_count??'0'),parseInt(target.value))
      new_row.sheet_total=sheet_total
    }
    if(target.name.startsWith('box_count')){
      let sheet_total = calculate_total_sheets(parseInt(target.value ),parseInt(row.sheet_count??'0'))
      new_row.sheet_total=sheet_total
    }
    setRow(pre=>new_row)
  }

  // const handleCopyLine = (index: string) => {
    
  //   //if (formik.values.order_details.length > parseInt(index)) {
  //   if (formik.values.purchaseorderdetail && formik.values.purchaseorderdetail?.length > parseInt(index)) {
  //     let new_details = [
  //       ...formik.values.purchaseorderdetail,
  //       { ...formik.values.purchaseorderdetail[parseInt(index)] },
  //     ];
  //     formik.setFieldValue('purchaseorderdetail', new_details);
     
  //   }
  // };
    const handleCopyLine = (arr_index: string[]) => {
  
      if (formik.values.purchaseorderdetail && formik.values.purchaseorderdetail?.length >= arr_index.length) {
        let new_rows = arr_index.map(ele =>
          ({...formik.values.purchaseorderdetail?.[parseInt(ele)]})
        )
        let new_details = [
          ...formik.values.purchaseorderdetail,
          ...new_rows
        ];
        //dispatch(orderSlice.actions.copyGlassWorks({ arr_index }))
        formik.setFieldValue('purchaseorderdetail', new_details);
  
      }
    };
  

  // const handleRemoveLine = (index: string) => {
  //   if (order_id?havePermission("Edit Purchase Order"):havePermission("Add Purchase Order")){
  //   let new_formoption = { ...formOptions };
  //   new_formoption.index =
  //     new_formoption.index > 0
  //       ? new_formoption.index - 1
  //       : formik.values.purchaseorderdetail?.length - 2 >= 0
  //       ? formik.values.order_details.length - 2
  //       : 0;
  //   new_formoption.dirty = true;
  //   let new_fields = formik.values.order_details.filter(
  //     (ele, i) => i !== parseInt(index),
  //   );

  //   formik.setValues((pre) => ({ ...pre, order_details: new_fields }));
  //   setFormOptions((pre) => ({ ...pre, ...new_formoption }));
  //   }
  //   else {
  //     let message =t("no_edit_permission")
  //     alert({en:message,ar:message},'info')
  //   }

  // };
    const handleRemoveLine = (arr_index: string[]) => {
      if (order_id?havePermission("Edit Purchase Order"):havePermission("Add Purchase Order")) {
        // let new_formoption = { ...formOptions };
        // new_formoption.current_index =
        //   new_formoption.current_index > 0
        //     ? new_formoption.current_index - 1
        //     : formik.values.order_details && formik.values.order_details?.length - 2 >= 0
        //       ? formik.values.order_details?.length - 2
        //       : 0;
        // new_formoption.dirty = true;
        let new_fields = formik.values.purchaseorderdetail?.filter(
          (ele, i) => !arr_index.includes(i.toString()),
        );
        //dispatch(orderSlice.actions.deleteGlassWorks({ arr_index: arr_index }))
  
  
        // remove_id_glass_id_fetched(arr_index.map(ele=>parseInt(ele)))
  
        //setFormOptions((pre) => ({ ...pre, ...new_formoption }));
        formik.setValues((pre: any) => ({ ...pre, purchaseorderdetail: new_fields }));
  
      } else {
        let message = t('no_add_permission');
        alert({ en: message, ar: message }, 'info');
      }
  
    };
  const addPurchaseOrder = () => {
    if (formik.values.purchaseorderdetail && formik.values.purchaseorderdetail?.length > 0) {
      let valid_orderdetails = true;
      
        if (!order_id) {
          setLoading(true);

          api
            .purchaseOrder()
            .store({
              date: convertDate(formik.values.date??''),
              order_no: formik.values.order_no??'',
              summary: formik.values.summary??'',
              order_details: formik.values.purchaseorderdetail,
              supplier_id: formik.values.supplier?.id??-1,
            })
            .then((res: any) => {
              setLoading(false);
              if (res.data && res.data.data && res.data.data.id) {
                dispatch(purchaseOrdersSlice.actions.addOrder([res.data.data]));
                navigate(`/add-purchase-order/${res.data.data.id}`);
                alert(
                  {
                    en: 'your order has been added successfully',
                    ar: 'تمت اضافة الطلب بنجاح',
                  },
                  'success',
                );
              } else {
                Object.keys(res.data.data).map((ele) =>
                  alert(
                    { en: res.data.data[ele][0], ar: res.data.data[ele][0] },
                    'error',
                  ),
                );
              }
            })
            .catch((err) => {
              setLoading(false);
              alertError500(err);
            });
        } else {
          setLoading(true);
          api
            .purchaseOrder()
            .update({
              id: parseInt(order_id),
              date: convertDate(formik.values.date??''),
              order_details: formik.values.purchaseorderdetail,
              order_no: formik.values.order_no??'',
              summary: formik.values.summary??'',
              supplier_id: formik.values.supplier?.id
                ? formik.values.supplier.id
                : 0,
            })
            .then((res: any) => {
              if (res.data.data && res.data.data.id) {
            
                alert(
                  { en: 'Your Update was successfull', ar: 'تم التحديث بنجاح' },
                  'success',
                );
                setLoading(false);
                dispatch(
                  purchaseOrdersSlice.actions.updateOrder(res.data.data),
                );
              } else {
                Object.keys(res.data.data).map((ele) =>
                  alert(
                    { en: res.data.data[ele][0], ar: res.data.data[ele][0] },
                    'error',
                  ),
                );
              }
            })
            .catch((err: any) => {
              setLoading(false);
              alertError500(err);
            });
        
      } 
    } else {
      alert(
        {
          en: 'you have to provide details for your order',
          ar: ' يجب عليك اضافة تفاصيل للطلبية ',
        },
        'info',
      );
    }
  };

  // const customHandleChange = (e: React.ChangeEvent, index: number) => {
  //   if (order_id? havePermission("Edit Purchase Order"):havePermission("Add Purchase Order")){
  //   let triggiring_autofilling_fields = [
  //     'width',
  //     'length',
  //     'box_count',
  //     'sheet_count',
  //   ];
  //   let new_formOptions = { ...formOptions, index };
  //   if (formik.values.invoice_issued === 1) return;
  //   if (order_id) new_formOptions.dirty = true;
  //   setFormOptions(new_formOptions);

  //   formik.handleChange(e);

  //   triggiring_autofilling_fields.map((ele) => {
  //     if ((e.target as HTMLInputElement).name.includes(ele)) {
  //       setAutoFilling((pre) => ({
  //         ...pre,
  //         field: (e.target as HTMLInputElement).name,
  //       }));
  //     }
  //   });
  // }
  // else {
  //   let message = order_id?t("no_edit_permission"):t("no_add_permission")
  //   alert({en:message,ar:message},'info')
  // }
  // };

  const customchangeHandler = (e: React.ChangeEvent,index:number) => {
    if (order_id? havePermission("Edit Purchase Order"):havePermission("Add Purchase Order")){
    if (formik.values.invoice_issued === 1) return;
      let target = e.target as HTMLInputElement
       type row_key = keyof iPurchaseOrderDetail
       type fields_key = keyof iPurchaseOrderResponse
      
      let match = target.name.match(/\[(\w+)\]$/)
      let _input_name = match ? match[1] : ''
      let new_row:{[k in row_key]?:any}= {...formik.values?.purchaseorderdetail?.[index]}
      new_row[_input_name as row_key]=target.value
    if (_input_name.startsWith('width')){
      let area = calculate_area(parseInt(new_row.length??'0'),parseInt(target.value))
       new_row.area=area.toString()
    }
    if(_input_name.startsWith('length')){
       let area = calculate_area(parseInt(target.value),parseInt(new_row.width??'0'))
       new_row.area=area.toString()
    }
    if(_input_name.startsWith('sheet_count')){
      let sheet_total = calculate_total_sheets(parseInt(new_row.box_count??'0'),parseInt(target.value))
      new_row.sheet_total=sheet_total.toString()
    }
    if(_input_name.startsWith('box_count')){
      let sheet_total = calculate_total_sheets(parseInt(target.value ),parseInt(new_row.sheet_count??'0'))
      new_row.sheet_total=sheet_total.toString()
    }
    let new_purchaseorderdetails:Partial<iPurchaseOrderResponse>[]|undefined = formik.values.purchaseorderdetail?.map(ele=>ele)
    if (new_purchaseorderdetails)new_purchaseorderdetails[index]=new_row
    formik.setValues(pre=>({...pre,purchaseorderdetail:new_purchaseorderdetails}))

    }
    else {
      let message = order_id?t("no_edit_permission"):t("no_add_permission")
      alert({en:message,ar:message},'info')
    }
  };

  const removeOrder = () => {
    if (order_id) {
      api
        .purchaseOrder()
        .delete({ ids: [parseInt(order_id)] })
        .then((res: any) => {
          navigate('/purchase-orders');
        })
        .catch((err: any) => {
          alertError500(err);
        });
    }
  };

  const deleteItem = () => {
    Confirm({
      message: t('delete_confirmation'),
      onConfirm: () => removeOrder(),
    });
  };
  const resetForm = (res: any) => {
    formik.resetForm({
      values: {
        ...res.data.data,
        purchaseorderdetail: res.data.data.purchaseorderdetail.map((ele: any) => ({
          area: ele.area,
          width: ele.width,
          length: ele.length,
          sheet_total: ele.sheet_total,
          sheet_count: ele.sheet_count,
          box_count: ele.box_count,
          description: ele.description,
          glass_id: ele.glass_id,
        })),
      },
    });
  };
  // useEffect(() => {
  //   handleAutoFilling();
  // }, [autoFilling]);
  // useEffect(() => {
  //   if (
  //     formik.values &&
  //     Object.keys(formik.values['order_details']).length > 0
  //   ) {
  //     let keys: string[] = Object.keys(formik.values.order_details);
  //     let empty = false;
  //     let last_line =
  //       formik.values.order_details[parseInt(keys[keys.length - 1])];
  //     Object.values(last_line).map((val) => {
  //       if (!Boolean(val)) {
  //         empty = true;
  //         return;
  //       }
  //     });

  //     if (!empty) handleAddLine();
  //   }
  // }, [formik.values.order_details]);


  useEffect(() => {
    getGlasses(1);
  }, []);

//// Auto Calculate for area ////
const calculate_area= (length?:number,width?:number)=> length && width?((length * width)/10000).toFixed(2):0

// useEffect(()=>{
//   if (row.length && row.width) {
//     let new_area= parseInt(row.length) * parseInt(row.width)/10000
//     setRow(pre=>({...pre,area:new_area.toString()}))
//   }
// },[row.length,row.width])

///////////// Auto Calculate Total sheets //////
const calculate_total_sheets= (box_count?:number,sheet_count?:number)=> box_count&& sheet_count? box_count* sheet_count:0
// useEffect(()=>{
//   if (row.box_count && row.sheet_count) {
//     let new_total_sheets= parseInt(row.box_count) * parseInt(row.sheet_count)
//     setRow(pre=>({...pre, sheet_total:new_total_sheets.toString()}))
//   }
// },[row.box_count,row.sheet_count])



  // useEffect(() => {
  //   if (!order_id) {
  //     if (
  //       Boolean(formik.values.supplier.supplier_id) &&
  //       Boolean(formik.values.date) &&
  //       Boolean(formik.values.summary) &&
  //       Boolean(formik.values.order_no)
  //     ) {
  //       setDisable(false);
  //     } else {
  //       setDisable(true);
  //     }
  //   } else {
  //     if (
  //       Boolean(formik.values.supplier.id) &&
  //       Boolean(formik.values.date) &&
  //       Boolean(formik.values.summary) &&
  //       Boolean(formik.values.order_no)
  //     ) {
  //       setDisable(false);
  //     } else {
  //       setDisable(true);
  //     }
  //   }
  // }, [formik.values]);

  useEffect(() => {
    if (!glassesError) {
      if (glassesData && glassesData.length > 0) {
        let data = glassesData.map((ele) => ({ ...ele, value: ele.id }));
        setGlasses(data);
      }
    }
  }, [glassesDataLoading]);
  useEffect(() => {
    if (order_id) {
      setFetching(true);
      api
        .purchaseOrder()
        .show({ id: parseInt(order_id) })
        .then((res: any) => {
          setFetching(false);
          if (res.data) {
            resetForm(res);
          }
        })
        .catch((err) => {
          setFetching(false);
          alertError500(err);
        });
    }
  }, [order_id]);
 
   let units: { [key: string]: string } = {}
  let key2=t('total_area')
  let key3=t('width')
  let key4 = t('length')
   units[key2]=`(${t('m')}²)`
   units[key3]=`(${t("cm")})`
   units[key4]=`(${t("cm")})`



//console.log ('values',formik.values)
 //console.log('errors',formik.errors)

  if (fetching) {
    return <WhiteboxLoader />;
  }
  return (
    <Grid container padding={4} rowGap={2}>
      {/* <Grid container  size={12} justifyContent={'flex-end'}>
       
    
       
          <Backbutton previousPageRoute="/purchase-orders" />
      </Grid> */}
      <Grid   size={12} >
           <Title title={order_id ?t('purchase_order') :t("add")+" "+t("purchase_order")} 
           backbutton_path='/purchase-orders'/>
        </Grid>
     
     
      <Grid container size={12} >
          {formik.values.invoice_issued === 1 && (
                  <Grid size={{sm:5, xs:12}} >
                
                    <Typography
                    sx={{
                          color: 'black',
                          fontWeight: 'bold',
                          fontSize: '1rem',
                        }}
                        
                    >
              {getLanguage() === 'en'
                        ? 'This Order has an invoice issued and can not be modified'
                        : '   هذه الطلبية تم اصدار فاتورة منها ولا يمكن تعديلها '}
                    </Typography>
                 
                
                
                </Grid>
                 )}

          <Grid  size ={{ sm:3, xs:3}} >
                <IconButton
                  value={formik.values.invoice_issued ? true : false}
                  doTitle={t('issue_invoice')}
                  disabled={
                    havePermission("Issue Purchase Bill")?
                    formik.values.order_status === 'Approved' ? false : true:true
                  }
                  cancelTitle={t('cancel_invoice_issued')}
                  doFunction={() => {
                    if (
                      havePermission('Show Bill') &&
                      havePermission('Edit Order')
                    ) {
                      dispatch(
                        purchaseOrdersSlice.actions.updateInvoiceIssued({
                          id: order_id ? parseInt(order_id) : 0,
                          invoice_issued:
                            formik.values.invoice_issued === 0 ? 1 : 0,
                        }),
                      );
                      if (
                        formik.values.invoice_issued === 0 &&
                        formik.values.order_status === 'Approved'
                      ) {
                        navigate(`/create-purchase-bill/${order_id}}/`);
                      } else {
                        if (formik.values.invoice_issued !== 0) {
                          alert(
                            {
                              en: 'This order has been issued before ',
                              ar: 'تم اصدار فاتورة هذه الطلبية من قبل',
                            },
                            'info',
                          );
                        }
                        if (formik.values.order_status !== 'Approved') {
                          alert(
                            {
                              en: 'This order must be approved in order to issue bill of it ',
                              ar: 'هذه الطلبية يجب الموافق عليها قبل اصدار فاتورة منها ',
                            },
                            'info',
                          );
                        }
                      }
                      return true;
                    }
                  }}
                  DoIcon={<Receipt style={{ color: 'var(--primary-color)' }} />}
                />
            </Grid>
              {order_id && (
                <Grid  size ={{sm:3}}   flexGrow={1}>
                  <UpdateOrderStatus
                    id={order_id ? parseInt(order_id) : 0}
                    resetForm={resetForm}
                    current_Status={formik.values.order_status??'Pending'}
                    unChangable={formik.values.invoice_issued === 1}
                    haveApprovePermission={havePermission("Approve Purchase Order")}
                    haveWaitPermission={havePermission("Wait")}
                    haveRejectPermission={havePermission("Reject Purchase Order")}
                  />
                </Grid>
              )}
      </Grid>
      <Grid container size ={12} columnGap={1}>
        <Grid container size= {{sm:5, xs:12}}  rowGap={1} columnGap={1}>
          <Grid size={12}>
            <SuppliersMenu
              placeholder={t('select_supplier') + ' *'}
              onChange={(selected: { value: number; label: string }) => {
                if (havePermission("Edit Purchase Order")){
                if (formik.values.invoice_issued === 1) return;
                //setFormOptions((pre) => ({ ...pre, dirty: true }));
                formik.setFieldValue('supplier', {
                  id: selected.value,
                  name: selected.label,
                });
              }
              else {
                let message =t("no_edit_permission")
                alert({en:message,ar:message},'info')
              }
              }}
              value={
                !order_id
                  ? formik.values.supplier?.id
                    ? {
                        value: formik.values.supplier.id,
                        label: formik.values.supplier.name,
                      }
                    : null
                  : {
                      value: formik.values.supplier?.id,
                      label: formik.values.supplier?.name,
                    }
              }
            />
          </Grid>
          <Grid size={12}>
            <InputField
              name="order_no"
              label={t('order_no')}
              value={formik.values.order_no}
              onChange={formik.handleChange}
              fullWidth={true}
              onBlur={formik.handleBlur}
              error={formik.errors.order_no}
            />
          </Grid>

          <Grid size={12}>
            <InputField
              name={'date'}
              value={formik.values.date}
              type={'date'}
              fullWidth={true}
              disabled={!havePermission('Edit Bill')}
              onChange={formik.handleChange}
            />
          </Grid>

        </Grid>
        <Grid size ={{sm:5, xs:12}} >
          <Textarea
            name="summary"
            label={t('summary')+"*"}
            value={formik.values.summary}
            onChange={formik.handleChange}
            style={{height:'100%'}}
            container_style={{height:'90%'}}
            error={formik.errors.summary}
            
            
          />
        </Grid>
      </Grid>
      <Grid size={12}>
        <InputTable
              headers={[
                t('description'),
                <>{t('total_area') + " " + `(${t('m')})`}<sup>2</sup></> ,
                t('width')+" "+`(${t('cm')})`,
                t('length')+" "+`(${t('cm')})`,
                t('sheet_total'),
                t('sheet_count'),
                t('box_count'),
                t('glass'),
              ]}
              body={() => generateTableBody()}
            />
      </Grid>
        {!isPc && <Grid size={12} justifyContent={'center'}>
                {enterButton(enterClicked)}
              </Grid>}
      <Grid container size={12}>
        {/* <EditbleTable
          handleChange={()=>{}}
          handleBlur={formik.handleBlur}
          error={formik.errors}
          lines_number={
            formik.values.purchaseorderdetail ? formik.values.purchaseorderdetail.length : 0
          }
          values={
            formik.values.purchaseorderdetail
              ? formik.values.purchaseorderdetail.map((ele) => ({
                  description: ele.description,
                  area: ele.area,
                  width: ele.width,
                  length: ele.length,
                  sheet_total: ele.sheet_total,
                  sheet_count: ele.sheet_count,
                  box_count: ele.box_count,
                  glass_id: ele.glass_id,
                }))
              : []
          }
          touched={formik.touched}
          array_name="purchaseorderdetail"
          number_inputs={[
            'area',
            'width',
            'length',
            'sheet_total',
            'box_count',
            'sheet_count',
          ]}
          headers={[
            t('description'),getLanguage()==='en'?
            <span>Totall Area M<sup>2</sup></span> : <span> المساحة الاجمالية م<sup>2</sup></span>,
            t('width')+" "+(t('cm')),
            t('length')+" "+(t('cm')),
            t('sheet_total'),
            t('sheet_count'),
            t('box_count'),
            t('glass'),
          ]}
          selectInput={['glass_id']}
          options={{ glass_id: glasess }}
          copyLine={handleCopyLine}
          removeLine={
            order_id
              ? formik.values.invoice_issued === 0
                ? ()=>{}
                : undefined
              : ()=>{}
          }
        /> */}
        <EditbleTable 

        handleChange={customchangeHandler}
          handleBlur={formik.handleBlur}
          error={formik.errors}
          lines_number={
            formik.values.purchaseorderdetail ? formik.values.purchaseorderdetail.length : 0
          }
          values={(
            ()=>{
             let obj: { [key: number]: iPurchaseOrderDetail } = {};
           if( formik.values && formik.values.purchaseorderdetail){
              formik.values.purchaseorderdetail?.map((ele,index) =>{ 
                obj[index]={
                  description: ele.description,
                  area: ele.area,
                  width: ele.width,
                  length: ele.length,
                  sheet_total: ele.sheet_total,
                  sheet_count: ele.sheet_count,
                  box_count: ele.box_count,
                  glass_id: ele.glass_id
                }
                }
                )}
            
                return obj
            }
            
            )()
          }
          touched={formik.touched}
          array_name="purchaseorderdetail"
          number_inputs={[
            'area',
            'width',
            'length',
            'sheet_total',
            'box_count',
            'sheet_count',
          ]}
          headers={[
            t('description'),
         t('total_area'),
            t('width'),
            t('length'),
            t('total_sheets'),
            t('sheets_number'),
            t('boxes_number'),
            t('glass'),
          ]}
          selectInput={['glass_id']}
          options={{ glass_id: glasess }}
          copyLine={handleCopyLine}
          removeLine={
            order_id
              ? formik.values.invoice_issued === 0
                ?handleRemoveLine
                : undefined
              :handleRemoveLine
          }
        />
      </Grid>

      {formik.values.invoice_issued !== 1 && (
        <Grid  container size={12} justifyContent={'center'}>
          <Grid container size={6} justifyContent={'center'}>
            <Grid size= {{xs:3}} mx={1}>
              <GreenButton
                fullWidth={true}
                label={t('save')}
                
                fun={() => addPurchaseOrder()}
                disabled={
                  !order_id ? formik.dirty &&formik.isValid?false:true : 
                  !(havePermission("Edit Purchase Order")) || !formik.dirty || !formik.isValid}
                loading={loading}>
                <Save sx={{ color: 'white' }} />
              </GreenButton>
            </Grid>
            <Grid size={3} mx={1}>
              <WhiteButton
                fullWidth={true}
                label={t('cancel')}
                fun={() => navigate('/purchase-orders')}>
                <Cancel sx={{ color: 'red' }} />
              </WhiteButton>
            </Grid>

            {order_id && (
              <Grid size={3} mx={1}>
                <WhiteButton
                  fullWidth={true}
                  label={t('delete')}
                  disabled={!havePermission("Delete Purchase Order")}
                  fun={() => deleteItem()}>
                  <Delete sx={{ color: 'red' }} />
                </WhiteButton>
              </Grid>
            )}
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};
